import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr.json';
import de from './de.json';

export const LANGS = ['fr', 'de'] as const;
export type Lang = (typeof LANGS)[number];
const STORAGE_KEY = 'gnosis.lang';

function initialLang(): Lang {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'fr' || saved === 'de') return saved;
    // À défaut, on suit la langue du navigateur (DE si allemand, FR sinon).
    return navigator.language?.toLowerCase().startsWith('de') ? 'de' : 'fr';
  } catch {
    return 'fr';
  }
}

// Interface bilingue FR/DE (I18N-01). Le contenu (grains) n'est pas traduit.
void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, de: { translation: de } },
  lng: initialLang(),
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
});

/** Change la langue de l'interface et mémorise le choix. */
export function setLang(lang: Lang): void {
  void i18n.changeLanguage(lang);
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* stockage indisponible : langue gardée pour la session */
  }
}

export default i18n;
